import styled, { css } from 'styled-components';

import { FormDialog, FormField, Popover, defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledEditorContainer = styled.div`
  position: relative;
  cursor: text;

  .ProseMirror:focus {
    outline: none;
  }
`;

StyledEditorContainer.defaultProps = defaultThemeProp;

interface StyledEditorIframeProps {
  $minHeight?: number;
  $maxHeight?: number;
  $hidden?: boolean;
}

export const StyledEditorIframe = styled.iframe<StyledEditorIframeProps>(
  ({ theme, $minHeight, $maxHeight, $hidden }) => {
    const minHeightValue = $minHeight
      ? `${$minHeight}px`
      : theme.components['text-area']['min-height'];
    const maxHeightValue = $maxHeight ? `${$maxHeight}px` : undefined;

    return css`
      display: block;
      width: 100%;
      border: none;
      min-height: ${minHeightValue};
      ${maxHeightValue &&
      css`
        max-height: ${maxHeightValue};
        overflow: auto;
      `}
      ${$hidden &&
      css`
        position: absolute;
        visibility: hidden;
        pointer-events: none;
      `}
    `;
  }
);

StyledEditorIframe.defaultProps = defaultThemeProp;

export const StyledEditorRoot = styled(FormField)``;

StyledEditorRoot.defaultProps = defaultThemeProp;

export const StyledEditPopover = styled(Popover)(({ theme }) => {
  const contentWidth = theme.base['content-width'];

  return css`
    overflow: auto;
    min-width: min(${contentWidth.sm}, calc(100vw - 2rem));
    max-width: min(${contentWidth.lg}, calc(100vw - 2rem));
  `;
});

StyledEditPopover.defaultProps = defaultThemeProp;

export const StyledFormDialog = styled(FormDialog)`
  overflow: auto;
`;

StyledFormDialog.defaultProps = defaultThemeProp;

interface StyledSourceTextareaProps {
  $minHeight?: number;
  $maxHeight?: number;
}

export const StyledSourceTextarea = styled.textarea<StyledSourceTextareaProps>(
  ({ theme, $minHeight, $maxHeight }) => {
    const minHeightValue = $minHeight
      ? `${$minHeight}px`
      : theme.components['text-area']['min-height'];
    const maxHeightValue = $maxHeight ? `${$maxHeight}px` : undefined;

    return css`
      display: block;
      width: 100%;
      border: none;
      min-height: ${minHeightValue};
      font-family: monospace;
      font-size: ${theme.base['font-size']};
      padding: ${theme.base.spacing};
      resize: none;
      background-color: ${theme.components['form-control']['background-color']};
      color: ${theme.base.palette['foreground-color']};

      ${maxHeightValue &&
      css`
        max-height: ${maxHeightValue};
        overflow: auto;
      `}

      &:focus {
        outline: none;
        box-shadow: ${theme.base.shadow.focus};
      }
    `;
  }
);

StyledSourceTextarea.defaultProps = defaultThemeProp;
